module.exports = __webpack_public_path__ + "img/culture_2.c144bd4c.png";